module.exports = __webpack_public_path__ + "img/9788983948090.dd592c83.jpg";